module.exports = __webpack_public_path__ + "static/media/12.9628d277.jpg";